import { createSlice } from '@reduxjs/toolkit';
import { clearToken } from '../../request';

const initialState = {
  isLoggedIn: false,
  user: null,
  isLoading: false,
  isInitializing: true,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.isLoading = false;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.isLoading = false;
      clearToken();
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setInitializing: (state, action) => {
      state.isInitializing = action.payload;
    },
    updateOrgCover: (state, action) => {
      if (state.user && state.user.org) {
        state.user.org.cover = action.payload;
      }
    },
  },
});

export const { login, logout, setLoading, setInitializing, updateOrgCover } =
  slice.actions;
export default slice.reducer;
